import React from 'react'
import { connect } from 'react-redux'
import { searchOrders } from '../../actions/order-actions'
import { Grid, Row, Table } from 'react-bootstrap'
import qs from 'qs'
import moment from 'moment'

import SearchBar from '../../components/SearchBar'
import Breadcrumbs from '../../components/Breadcrumbs'

import { SEARCH_INSTRUCTIONS, NO_SEARCH_RESULTS } from '../messages'

class OrderOverview extends React.Component {

  constructor() {
    super()
    this.state = { query: undefined }
  }

  componentDidMount() {
    if (this.props.location.search) {
      let params = qs.parse(this.props.location.search.substring(1))
      this.setState({ query: params.query})
      this.props.searchOrders(params.query)
    }
  }

  search(query) {
    this.props.searchOrders(query)
  }

  render() {
    const { searchResults } = this.props

    return <Grid>
      <Breadcrumbs/>
      <SearchBar value={this.state.query || searchResults.query} action='/orders' placeholder='Zoek order' callback={(query) => this.search(query)} />

      <Row>
        <div className='tablescontainer'>
        { searchResults.length > 0 ? <Table striped>
            <thead>
              <tr>
                <th>NavisionId</th>
                <th>Datum</th>
                <th>Klant</th>
                <th>Werkmaatschappij</th>
              </tr>
            </thead>
            <tbody>
              { searchResults.map((order, index) =>
                <tr key={index} onClick={() => this.props.history.push(`/orders/${order.id}`)}>
                  <td>{order.navisionId}</td>
                  <td>{moment(order.date).format('DD-MM-YYYY')}</td>
                  <td>{order.customer.name}<br/>
                  {order.customer.email}</td>
                  <td>{order.subsidiaryName}</td>
                </tr>
              )}
            </tbody>
          </Table>
        : <SearchInfo/>}
        </div>
      </Row>
    </Grid>
  }
}

let SearchInfo = () => (
  <div>
    <p>{SEARCH_INSTRUCTIONS}</p>
    <p>Zoek op:</p>
    <ul>
      <li>Navision Order ID</li>
      <li>Orderdatum</li>
      <li>Klant
        <ul>
          <li>Navision ID</li>
          <li>Email</li>
          <li>Naam</li>
        </ul>
      </li>
      <li>Orderregel
        <ul>
          <li>Navision ID</li>
          <li>Webshop-orderitem-ID</li>
          <li>EAN</li>
          <li>Email</li>
          <li>Email-naam</li>
          <li>Startdatum licentie</li>
          <li>Einddatum licentie</li>
          <li>Rol</li>
        </ul>
      </li>

    </ul>
    <p>{NO_SEARCH_RESULTS}</p>
  </div>
)


export default connect((state) => { return { searchResults: state.orders.searchResults }}, {
  searchOrders
})(OrderOverview)
